import { StyledButton } from "react-common-ui-library";
import { StyledVerifyAccountButtonBox } from "../../Styles/Login/VerifyAccount/VerifyAccountStyles";
import {
  VERIFY_ACCOUNT_FORM,
  VERIFY_CODE_BUTTON,
} from "../../Constants/VerifyAccountConstants";
import { SUBMIT, CONTAINED } from "../../Constants/CommonConstants";
import { useIntl } from "react-intl";

/**
 * @description The Verify Account button that carries out the OTP validation on it's click
 * @returns {ReactNode} Renders the Verify Account button to the user for validating OTP
 */
export const VerifyAccountButton = () => {
  const intl = useIntl();

  return (
    <StyledVerifyAccountButtonBox>
      <StyledButton
        variant={CONTAINED}
        type={SUBMIT}
        id={VERIFY_CODE_BUTTON}
        form={VERIFY_ACCOUNT_FORM}
      >
        {intl.formatMessage({
          id: VERIFY_CODE_BUTTON,
        })}
      </StyledButton>
    </StyledVerifyAccountButtonBox>
  );
};
